module.exports = (__parcel__import__("9OTEE")).then(() => parcelRequire('8OYBW'));